export default "__VITE_ASSET__Gtd88pzv__"